import React from 'react';
import { Container, Box, Typography, Button, Card, CardContent } from '@mui/material';
import { Phone, WhatsApp } from '@mui/icons-material';

export const ContactSection: React.FC = () => {
    return (
        <Box
            id="contact"
            sx={{
                py: { xs: 8, md: 12 },
            }}
        >
            <Container maxWidth="lg">
                <Typography
                    variant="h2"
                    sx={{
                        mb: 6,
                        textAlign: 'center',
                        background: 'linear-gradient(135deg, #5b4cdb 0%, #1e293b 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                    }}
                >
                    Contact Myl 
                </Typography>

                <Card sx={{ maxWidth: 700, mx: 'auto' }}>
                    <CardContent sx={{ p: { xs: 4, md: 6 }, textAlign: 'center' }}>
                        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary', lineHeight: 1.8 }}>
                            Give your child the best possible start on their <strong>11+ journey</strong>. Contact
                            us to book a <strong>free consultation</strong>, arrange an{' '}
                            <strong>initial assessment</strong>, or learn more about our courses.
                        </Typography>

                        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap', mb: 4 }}>
                            <Button
                                variant="contained"
                                size="large"
                                startIcon={<Phone />}
                                href="tel:+447459240172"
                            >
                                Call: +44 7459 240172
                            </Button>
                            <Button
                                variant="outlined"
                                size="large"
                                startIcon={<WhatsApp />}
                                href="https://wa.me/447459240172"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Message on WhatsApp
                            </Button>
                        </Box>

                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 600,
                                background: 'linear-gradient(135deg, #5b4cdb 0%, #06b6d4 100%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                            }}
                        >
                            Myl – Where Preparation Meets Confidence.
                        </Typography>
                    </CardContent>
                </Card>
            </Container>
        </Box>
    );
};
